import React, {useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {changePageTitle, setAlert} from "../redux/actions";
import {Delete as DeleteIcon} from "@mui/icons-material";
import {CaptureService} from "./capture.service";
import {useNavigate} from "react-router-dom";
import {PageParams} from "../util/page-params";
import {Capture} from "./capture";
import {ColorButtonEnum} from "../util/color-button-enum";
import {ColorIconEnum} from "../util/color-icon-enum";
import Datatable from "../datatable/datatable";

export function CaptureList() {

    let navigate = useNavigate();
    const [pageParams, setPageParams] = useState<PageParams>({
        number: 0,
        size: parseInt(process.env.REACT_APP_PAGE_SIZE || "0"),
        sort: "id,asc",
        filter: "",
        items: [],
        totalElements: 0
    });
    const dispatch = useDispatch();

    const findAll = useCallback(async (number?: number, size?: number, sort?: string, filter?: string) => {
        const result = await CaptureService.findAll(number, size, sort, filter);
        setPageParams({
            number: number,
            size: size,
            sort: sort,
            filter: filter,
            items: result.content,
            totalElements: result.totalElements
        });
    }, []);

    useEffect(() => {
        dispatch(changePageTitle("Captações"));
        findAll(pageParams.number, pageParams.size, pageParams.sort, pageParams.filter).then();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const editItem = (item: Capture) => {
        navigate('/capture/' + item.id);
    }

    const insertItem = () => {
        navigate('/capture');
    }

    const deleteItem = (item: Capture) => {
        if (item.id === undefined) {
            return;
        }
        CaptureService.delete(item.id).then(() => {
            findAll(pageParams.number, pageParams.size, pageParams.sort, pageParams.filter).then();
        }).catch((error) => {
            dispatch(setAlert({
                show: true,
                message: 'Erro ao excluir registro - ' + error.message,
                severity: 'error'
            }));
        })
    }

    const headerOperations = [
        {color: () => ColorButtonEnum.PRIMARY, onClick: insertItem, label: () => 'Inserir'}
    ]

    const rowOperations = [
        {color: () => ColorIconEnum.PRIMARY, onClick: deleteItem, label: () => 'Excluir', icon: () => <DeleteIcon/>},
    ]

    return pageParams && (
        <Datatable data={pageParams.items} totalData={pageParams.totalElements} dataColumnNames={['ID', 'Descrição']}
                   dataColumns={['id', 'description']} dataTypes={['number', 'text']} page={pageParams.number}
                   size={pageParams.size} sort={pageParams.sort} filter={pageParams.filter} findAll={findAll}
                   editData={editItem} headerOperations={headerOperations} rowOperations={rowOperations}/>
    );
}
